<script lang="ts">
import { defineComponent as DO_defineComponent } from 'vue';
export default /*#__PURE__*/ DO_defineComponent({
	name: 'ToDivider'
});
</script>
<template>
	<div :flex="flex ? flex : null" class="to-divider" :class="setClass" :style="setStyle"></div>
</template>
<script setup lang="ts">
import { computed, CSSProperties } from 'vue'



export interface Props {
	height?: string
	width?: string
	mode?: string
	dir?: string
	color?: string
	marginX?: string | number
	marginY?: string | number
	flex?: boolean
}

const props = withDefaults(defineProps<Props>(), {
	mode: 'default',
	dir: 'h',
	color: 'default',
	height: '',
	width: '',
	marginX: 0,
	marginY: 0,
	flex: false
})

const setClass = computed(() => {
	let arr: string[] = []
	if (props.mode) {
		arr.push(`mode-${props.mode}`)
	}
	if (props.dir) {
		arr.push(`dir-${props.dir}`)
	}
	if (props.color) {
		arr.push(`color-${props.color}`)
	}
	if (props.height === 'full') {
		arr.push(`height-full`)
	}
	return arr
})

const setStyle = computed(() => {
	const obj: CSSProperties = {}
	if (props.marginX) {
		if (!isNaN(Number(props.marginX))) {
			obj['--margin-x'] = props.marginX + 'em'
		} else {
			obj['--margin-x'] = props.marginX
		}
	}
	if (props.marginY) {
		if (!isNaN(Number(props.marginY))) {
			obj['--margin-y'] = props.marginY + 'em'
		} else {
			obj['--margin-y'] = props.marginY
		}
	}
	if (props.height) {
		if (!isNaN(Number(props.height))) {
			obj.height = props.height + 'em'
		} else if (props.height !== 'full') {
			obj.height = props.height
		}
	}
	if (props.width) {
		if (!isNaN(Number(props.width))) {
			obj.width = props.width + 'em'
		} else {
			obj.width = props.width
		}
	}
	return obj
})
</script>
